import { doDefaultFetch, doDefaultFetchWithBody } from '@nhl/fetch-helpers';

const fetchScreenersData = args => {
    return doDefaultFetch(
        `/site/api/screener` +
        `?sort=createdOn` +
        `&dir=DESC`,
        args
    );
};

const fetchScreenerData = id => {
    return doDefaultFetch(
        `/site/api/screener` +
        `?cayenneExp=vimeoVideoUrl like '%${id}%'`
    );
};

const fetchScreenerMetadata = url => {
    return doDefaultFetch(
        `https://vimeo.com/api/oembed.json?url=${url}`,
        {
            isPublic: true
        }
    );
};

const putScreenerAccessRequest = () => {
    return doDefaultFetchWithBody(
        `/account/rest/api/screenerrequest/me`,
        {
            method: 'PUT',
        }
    );
}

export default {
    fetchScreenersData,
    fetchScreenerData,
    fetchScreenerMetadata,
    putScreenerAccessRequest,
};